import { render, staticRenderFns } from "./CustomersSection.vue?vue&type=template&id=43db9672&"
import script from "./CustomersSection.vue?vue&type=script&lang=js&"
export * from "./CustomersSection.vue?vue&type=script&lang=js&"
import style0 from "./CustomersSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports